import { IWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useMemo } from "react";
import { ElementToPrint } from "share-components/templates/print/element";
import { TEXT_PRINT_COLOR, TEXT_PRINT_FONT_WEIGHT } from "../const";

export const useFrontPage2Elements = ({
  workOrderPoDetail,
}: {
  workOrderPoDetail: IWorkOrderPo;
}) => {
  const frontPage2Elements = useMemo<ElementToPrint[]>(() => {
    return [
      {
        name: "woNumber",
        value: workOrderPoDetail?.woNumber || "",
        top: "1.25cm",
        left: "3.28cm",
        height: "0.79cm",
        width: "3.44cm",
      },
      {
        name: "woBatchNumber",
        value: workOrderPoDetail?.woBatchNumber || "",
        top: "1.25cm",
        left: "8.3cm",
        height: "0.79cm",
        width: "1.30cm",
      },
    ];
  }, [workOrderPoDetail?.woNumber, workOrderPoDetail?.woBatchNumber]);

  return {
    frontPage2Elements: frontPage2Elements.map((item) => ({
      ...item,
      fontWeight: TEXT_PRINT_FONT_WEIGHT,
      textColor: TEXT_PRINT_COLOR,
    })),
  };
};
